import ItemCardSaveIcon from '@/components/GridItemCard/Card/components/ItemCardSaveIcon/ItemCardSaveIcon';
import { ImageRow } from '@/components/ItemCard/ImageRow';
import { useIsBrowsingPage } from '@/hooks/useIsBrowsingPage';

import { SeeSimilarItemsButtonSearchCard } from './SeeSimilarItemsButtonSearchCard';

export type CardImageProps = {
    applyDimensionToUrl?: boolean;
    canShowEasyShipping: boolean;
    className?: string;
    dimension?: number;
    enterLinkHoverState: () => void;
    imageQuality?: number;
    isLabeledFavoriteButton?: boolean;
    isMobile: boolean;
    itemId: number;
    lazyLoadImage: boolean;
    leaveLinkHoverState: () => void;
    onNavigate?: () => void;
    sharpenImage?: boolean;
    position?: number;
    shouldShowSeeSimilarItemsButtonIconCTA?: boolean;
};

const CardImage = ({
    applyDimensionToUrl,
    canShowEasyShipping,
    className,
    dimension,
    enterLinkHoverState,
    imageQuality,
    isLabeledFavoriteButton,
    isMobile,
    itemId,
    lazyLoadImage,
    leaveLinkHoverState,
    onNavigate,
    sharpenImage,
    position,
    shouldShowSeeSimilarItemsButtonIconCTA,
}: CardImageProps) => {
    const isBrowsingPage = useIsBrowsingPage();

    const isLabeled = shouldShowSeeSimilarItemsButtonIconCTA
        ? false
        : !isMobile && (isLabeledFavoriteButton || isBrowsingPage);

    return (
        <section className="relative">
            <span className="absolute right-2xs top-2xs z-[8] smMin:right-2 smMin:top-2">
                <ItemCardSaveIcon
                    canShowEasyShipping={canShowEasyShipping}
                    itemId={itemId}
                    labeled={isLabeled}
                    shouldShouldToolTipExperiment={shouldShowSeeSimilarItemsButtonIconCTA}
                />
            </span>
            <ImageRow
                applyDimensionToUrl={applyDimensionToUrl}
                className={`grid-area-itemimage ${className}`}
                dimension={dimension}
                imageQuality={imageQuality}
                itemId={itemId}
                lazyLoadImage={lazyLoadImage}
                onMouseEnter={enterLinkHoverState}
                onMouseLeave={leaveLinkHoverState}
                onNavigate={onNavigate}
                sharpenImage={sharpenImage}
                showImageWithHover={!isMobile}
            />

            {shouldShowSeeSimilarItemsButtonIconCTA && (
                <SeeSimilarItemsButtonSearchCard
                    isIconCTA={shouldShowSeeSimilarItemsButtonIconCTA}
                    isMobile={isMobile}
                    itemId={itemId}
                    position={position}
                />
            )}
        </section>
    );
};

export default CardImage;
